<template>
  <div class="text-center">
    <h3>403 Not Allowed</h3>
    <p>This portal is only available to Opendock Carriers.</p>
    <p>
      Warehouse users can <a :href="warehouseLoginURL">Log Into the Warehouse UI Here</a> or
      <a :href="registerURL">Create a Carrier Account</a>
    </p>
  </div>
</template>

<script>
export default {
  computed: {
    heliosUrl() {
      return this.config.helios_url;
    },
    warehouseLoginURL() {
      return `${this.heliosUrl}/login`;
    },
    registerURL() {
      return `${this.heliosUrl}/app/register`;
    }
  }
};
</script>
